import React from 'react'
import { useAuth } from '@/modules/auth/context/AuthContext'
import { fetchProfile, ensureProfile, updateProfile, type UserProfile } from '../services/profileService'

export function useProfileForm() {
  const { user } = useAuth()
  const [profile, setProfile] = React.useState<UserProfile | null>(null)
  const [loading, setLoading] = React.useState(true)
  const [saving, setSaving] = React.useState(false)
  const [error, setError] = React.useState<string | null>(null)

  const load = React.useCallback(async () => {
    if (!user?.id) { setProfile(null); setLoading(false); return }
    setLoading(true)
    setError(null)
    try {
      await ensureProfile(user.id, user.email || undefined)
      const p = await fetchProfile(user.id)
      setProfile(p)
    } catch (e: any) {
      setError(e?.message ?? 'Falha ao carregar perfil')
    } finally {
      setLoading(false)
    }
  }, [user?.id])

  React.useEffect(() => { load() }, [load])

  async function saveBasic(data: { full_name?: string | null; phone?: string | null; country?: string | null }) {
    if (!user?.id) return
    setSaving(true)
    setError(null)
    try {
      const p = await updateProfile(user.id, data)
      setProfile(p)
      return true
    } catch (e: any) {
      setError(e?.message ?? 'Falha ao salvar perfil')
      return false
    } finally {
      setSaving(false)
    }
  }

  return { user, profile, loading, saving, error, load, saveBasic, setProfile }
}
